import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getBundleOutWardList = (
    page,
    pagesize,
    search,
    ordering,
    workOrderId,
    start_date,
    end_date,
) => {
    try {
        return axios.get(
            `${API_URL}/api/${API_VERSION}/warehouse/get-warehouse-outward/`,
            {
                headers: authHeader(),
                params: {
                    deleted: 0,
                    page: page,
                    pagesize: pagesize,
                    search: search, // You might want to include search here, if applicable
                    ordering: ordering,
                    workOrderId: workOrderId,
                    ...(start_date && { start_date: start_date }),
                    ...(end_date && { end_date: end_date }),
                },
            },
        );
    } catch (error) {
        console.error('Error fetching bundle outward list:', error);
        throw error; // Ensure this is thrown for proper handling elsewhere
    }
};

const getItemByWorkOrderId = (id, page, pagesize, search, ordering) => {
    return axios.get(
        `${API_URL}/api/${API_VERSION}/workorder/${id}/get-workorder-details/`,
        {
            headers: authHeader(),
            params: {
                page: page,
                pagesize: pagesize,
                search: search,
                ordering: ordering,
            },
        },
    );
};

const getWorkOrderList = (page, pagesize, search, groupId, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/workorder/', {
        headers: authHeader(),
        params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        },
    });
};


const getBundleOutWardListById = id => {
    return axios.get(
        API_URL +
        '/api/' +
        API_VERSION +
        `/warehouse/get-warehouse-outward/?outward_id=${id}`,
        {
            headers: authHeader(),
        },
    );
};

const getBundlePackingSlipData = id => {
    return axios.get(
        API_URL +
        '/api/' +
        API_VERSION +
        `/warehouse/packing-slip-summary/?outward_id=${id}`,

        {
            headers: authHeader(),
        },
    );
};

const getBundlePackingSlipbundle = id => {
    return axios.get(
        API_URL +
        '/api/' +
        API_VERSION +
        `/warehouse/packing-slip-bundles/?outward_id=${id}`,
        {
            headers: authHeader(),
        },
    );
};

const getBundleOutWardByItem = (
    page,
    pagesize,
    search,
    id,
    ordering,
    workOrderId,
    bundleOutwardId,
) => {
    return axios.get(
        API_URL +
        '/api/' +
        API_VERSION +
        `/warehouse/workorder-detail-by-workorder-id/${workOrderId}/?outward_id=${bundleOutwardId}`,
        {
            headers: authHeader(),
            params: {
                deleted: 0,
                page: page,
                pagesize: pagesize,
                search: search,
                ordering: ordering,
            },
        },
    );
};
const getBundleByWorkorderId = (
    page,
    pagesize,
    search,
    id,
    ordering,
    workOrderId,
    addData,
    bundleOutwardId
) => {
    return axios.patch(
        API_URL +
        '/api/' +
        API_VERSION +
        `/warehouse/${id}/bundle-inward-by-workorder-details/outward_id=${bundleOutwardId}`,
        { exclude_bundles: addData },
        {
            headers: authHeader(),
        },
    );
};
const getBundleByWorkorderRestoreId = (
    page,
    pagesize,
    search,
    id,
    ordering,
    workOrderId,
    restoreData,
) => {
    return axios.patch(
        API_URL + '/api/' + API_VERSION + `/warehouse/add-item-by-bundle-id/`,
        { bundle_id: restoreData },

        {
            headers: authHeader(),
        },
    );
};
const getBundleOutWardById = id => {
    return axios.get(`${API_URL}/api/${API_VERSION}/warehouse/${id}`, {
        headers: authHeader(),
    });
};
const getBundleOutWardByIdFinalize = outward_id => {
    return axios.get(
        `${API_URL}/api/${API_VERSION}/warehouse/${outward_id}`,
        {
            headers: authHeader(),
        },
    );
};
const getArchiveBundleOutWardList = (page, pagesize, search, ordering) => {
    return axios.get(
        API_URL + '/api/' + API_VERSION + '/warehouse/?deleted=1',
        {
            headers: authHeader(),
            params: {
                page: page,
                pagesize: pagesize,
                search: search,
                ordering: ordering,
            },
        },
    );
};
const getBudlelistExist = (
    page,
    pagesize,
    search,
    ordering,
    bundleId,
    added,
    bundleOutwardId,
) => {
    return axios.get(
        API_URL +
        '/api/' +
        API_VERSION +
        `/warehouse/${bundleId}/bundle-inward-by-workorder-details/?outward_id=${bundleOutwardId}`,
        {
            headers: authHeader(),
            params: {
                page: page,
                pagesize: pagesize,
                search: search,
                added: added,
            },
        },
    );
};
const addBundleItem = async sizeData => {
    try {
        const response = await axios.post(
            `${API_URL}/api/${API_VERSION}/warehouse/add-item-by-bundle-id/`,
            sizeData,
            {
                headers: authHeader(),
            },
        );
        return response.data; // Assuming the response contains the created die size data
    } catch (error) {
        console.error('Error creating die size:', error);
        throw error; // Ensure proper error handling
    }
};
const restoreBundleItem = async sizeData => {
    try {
        const response = await axios.post(
            `${API_URL}/api/${API_VERSION}/warehouse/restore-item-by-bundle-id/`,
            sizeData,
            {
                headers: authHeader(),
            },
        );
        return response.data; // Assuming the response contains the created die size data
    } catch (error) {
        console.error('Error creating die size:', error);
        throw error; // Ensure proper error handling
    }
};
const deleteBundleOutwardList = id => {
    return axios.delete(
        `${API_URL}/api/${API_VERSION}/warehouse/${id}/`, // Include `id` in the URL
        {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data', // Ensure proper header for FormData
            },
        },
    );
};
const createBundleOutWard = async sizeData => {
    try {
        const response = await axios.post(
            `${API_URL}/api/${API_VERSION}/warehouse/`,
            sizeData,
            {
                headers: authHeader(),
            },
        );
        return response.data; // Assuming the response contains the created die size data
    } catch (error) {
        console.error('Error creating die size:', error);
        throw error; // Ensure proper error handling
    }
};
const finalizeBundleOutward = async sizeData => {
    try {
        const response = await axios.patch(
            `${API_URL}/api/${API_VERSION}/warehouse/bundle-finalize/`,
            sizeData,
            {
                headers: authHeader(),
            },
        );
        return response.data; // Assuming the response contains the created die size data
    } catch (error) {
        console.error('Error creating die size:', error);
        throw error; // Ensure proper error handling
    }
};
const editBundleOutWard = (id, SizeData) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/warehouse/${id}/`,
        SizeData,
        { headers: authHeader() },
    );
};

const BundleOutWardService = {
    getBundleOutWardList,
    getBundlePackingSlipData,
    getArchiveBundleOutWardList,
    createBundleOutWard,
    getBundleOutWardListById,
    editBundleOutWard,
    getBundlePackingSlipbundle,
    deleteBundleOutwardList,
    getItemByWorkOrderId,
    getWorkOrderList,
    getBundleOutWardByItem,
    getBundleOutWardById,
    getBundleOutWardByIdFinalize,
    getBundleByWorkorderId,
    getBundleByWorkorderRestoreId,
    getBudlelistExist,
    restoreBundleItem,
    addBundleItem,
    finalizeBundleOutward,
};

export default BundleOutWardService;
